import { render, staticRenderFns } from "./NetworkError.vue?vue&type=template&id=bc121b14&scoped=true&lang=pug"
import script from "./NetworkError.vue?vue&type=script&lang=ts"
export * from "./NetworkError.vue?vue&type=script&lang=ts"
import style0 from "./NetworkError.vue?vue&type=style&index=0&id=bc121b14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc121b14",
  null
  
)

export default component.exports